module.exports = __webpack_public_path__ + "img/3.fdbf44bb.png";